import styled from 'styled-components';

const BottomImage = styled.img`
  max-height: 285px;
  position: absolute;
  left: 0;
  bottom: -50px;
  max-width: 100%;
  transition: bottom 0.2s ease-in-out 0.1s;
`;

export default BottomImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ProductSlider/ProductSlide/BottomImage.jsx